import { loadStripe } from '@stripe/stripe-js/pure';

let stripePromise: ReturnType<typeof loadStripe> | null = null;

export const getStripe = () => {
  if (!stripePromise) {
    stripePromise = loadStripe(
      process.env.NEXT_PUBLIC_STRIPE_PUB_KEY as string
    );
  }
  return stripePromise;
};
